import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import {
  apiClient,
  LeaseRenewalLoaderResult,
} from "~/services/apiClient";
import * as APITypes from "~/API";
import { auth } from "~/lib/firebase";
import { getAuth } from "firebase/auth";
import { INTENTS, ROUTES } from "~/utils";
import { message } from "antd";
import { FormattedLeaseData } from "~/types";

export const LeaseRenewalPageLoader = async (
  _args: LoaderFunctionArgs
): Promise<LeaseRenewalPageLoaderType | Response> => {
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const result = await apiClient.loader<LeaseRenewalLoaderResult>(
    "lease-renewal"
  );

  if (!result.success || !result.data) {
    console.error("Lease renewal loader failed:", result.error);
    throw new Response(result.error ?? "Failed to load renewal data", {
      status: 500,
    });
  }

  return result.data;
};

export type LeaseRenewalPageLoaderType = {
  tenantInfo: APITypes.Tenant;
  activeLeaseData: FormattedLeaseData;
  nextLeaseData: FormattedLeaseData | null;
};

export const LeaseRenewalPageAction = async ({
  request,
}: ActionFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) redirect(ROUTES.home);

  const formData = await request.formData();
  const body = formData.get("body") as string;
  const intent = formData.get("intent");

  switch (intent) {
    case INTENTS._renew_lease: {
      let payload: Record<string, unknown>;
      try {
        payload = JSON.parse(body) as Record<string, unknown>;
      } catch {
        message.error("Invalid request");
        return { error: "Invalid request" };
      }

      const result = await apiClient.sendIntent(INTENTS._renew_lease, payload);

      if (result.success) {
        message.success(
          (payload.leaseValue as number) === 4
            ? "Lease marked as not renewing"
            : "Lease renewed successfully"
        );
      } else {
        message.error(result.error ?? "Failed to renew lease");
        return { error: result.error ?? "Failed to renew lease" };
      }
      break;
    }
    case INTENTS._agree_to_renewal: {
      let agreePayload: Record<string, unknown>;
      try {
        agreePayload = JSON.parse(body) as Record<string, unknown>;
      } catch {
        message.error("Invalid request");
        return { error: "Invalid request" };
      }

      const agreeResult = await apiClient.sendIntent(
        INTENTS._agree_to_renewal,
        agreePayload
      );

      if (agreeResult.success) {
        message.success("Agreement submitted");
      } else {
        message.error(agreeResult.error ?? "Failed to submit agreement");
        return { error: agreeResult.error ?? "Failed to submit agreement" };
      }
      break;
    }
  }
  return {};
};
